import type { Country } from '../types';
import type { RegistrationInfoResponseDto } from '@/features/auth-signup';

export const getPhoneCodeByCountryCode = (
  countriesData: Country[] | undefined,
  countryCode: string
) => {
  return (
    countriesData?.find(country => country.phoneCode === countryCode)
      ?.phoneCode || ''
  );
};

export const resolvePhoneCode = (
  countriesData: Country[] | undefined,
  registrationInfo: Partial<RegistrationInfoResponseDto> | undefined
) => {
  if (registrationInfo) {
    const { phoneCountryCode, countryByIp } = registrationInfo;

    if (phoneCountryCode) {
      const code = getPhoneCodeByCountryCode(countriesData, phoneCountryCode);
      if (code) return code;
    }
    if (countryByIp) {
      const code = getPhoneCodeByCountryCode(countriesData, countryByIp);
      if (code) return code;
    }
  }

  return '';
};

export const parsePhoneNumber = (
  fullPhoneNumber: string,
  countriesData: Country[] | undefined
): { phoneCode: string; phoneNumber: string } => {
  if (!fullPhoneNumber || !countriesData) {
    return { phoneCode: '', phoneNumber: fullPhoneNumber || '' };
  }
  const sortedCountries = [...countriesData].sort(
    (a, b) => b.phoneCode.length - a.phoneCode.length
  );

  for (const country of sortedCountries) {
    if (country.phoneCode && fullPhoneNumber.startsWith(country.phoneCode)) {
      return {
        phoneCode: country.phoneCode,
        phoneNumber: fullPhoneNumber.replace(country.phoneCode, ''),
      };
    }
  }

  return { phoneCode: '', phoneNumber: fullPhoneNumber };
};
